import React from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'

import Analytics from './HOC/Analytics'
import Title from './HOC/Title'
import Signup from '../components/Signup'

function SignupContainer({ location, data }) {
  return <Signup search={qs.parse(location.search)} data={data} />
}

SignupContainer.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
}

export default Title(Analytics(SignupContainer), 'Cadastre-se na Hi Platform')



// WEBPACK FOOTER //
// ./src/containers/Signup.js